import React, { Component, ReactElement, useState } from "react";

import PageLayout from '../../components/layout/PageLayout'
import { ThemeProps } from "../../components/styles/themeprops";
import { Fade } from "react-awesome-reveal";
import "./impressum.css";
import SitemapImg from "./sitemapImg";
import { handleLogError } from "../../components/misc/Helpers";
import { useTranslation } from "react-i18next";

type Props = { theme: ThemeProps, }
export default function Privacy({ theme }: Props) {


	const { t, i18n } = useTranslation();

	return (
		<PageLayout title="Home" theme={theme}>
			<div className="imprint">
				<div className="basic-projects">
					<Fade direction="left" duration={1000} damping={0.3} triggerOnce={true}>
						<div className="projects-heading-div">
							<div className="imprint-heading-img-div">
								{/* <img
											src={require(`../../assests/images/${projectsHeader["avatar_image_path"]}`)}
											alt=""
										/> */}
								<SitemapImg theme={theme} />
							</div>
							<div className="projects-heading-text-div">
								<h1 className="projects-heading-text">{t("accessibility.title")}</h1>
								<p className="projects-header-detail-text subTitle">
									{t("accessibility.description")}
								</p>
							</div>
						</div>
					</Fade>
				</div>
			</div>


			<div className="contact-form-div imprint">
				<h1 className="d-flex justify-content-center">{t("accessibility.title")}</h1>

				<div className="row d-flex align-items-center justify-content-center h-100">
					<div className="col-md-3 col-lg-3 col-xl-3"></div>
					<div className="col-md-6 col-lg-6 col-xl-6 ">
						<div className="float-end"></div>

						<h2>Home</h2>
						<ul className="index">
						  <li><a className="index-link" href="/services">{t("services")}</a></li>
						  <li><a className="index-link" href="/karrier">{t("career")}</a></li>
						  <li><a className="index-link" href="/about-pati">{t("aboutus")}</a></li>
						  <li><a className="index-link" href="/contact">{t("contact")}</a></li>
						  <li><a className="index-link" href="/login">{t("signin")}</a></li>
						  <li><a className="index-link" href="/Service/imprint">{t("imprint")}</a></li>
						  <li><a className="index-link" href="/Service/privacy">{t("privacy")}</a></li>
						  <li><a className="index-link" href="/Service/accessibility">{t("accessibility")}</a></li>
							<li><a className="index-link" href="/Service/imprint">{t("imprint")}</a></li>
						</ul>



					</div>
					<div className="col-md-3 col-lg-3 col-xl-3"></div>
				</div>

			</div>

		</PageLayout>
	);
}